export default __webpack_public_path__ + "static/media/noreference.76db9baa.svg";